import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, " 「スーシェフ」は料理のレシピ、及び、タイマーを管理するアプリです。 ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "※使用の際には広告を閲覧していただくことになりますが、定期購読で広告を非表示にすることが可能です。", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UpdatedView = _resolveComponent("UpdatedView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_UpdatedView),
    _hoisted_3
  ], 64))
}